import React, { useState, useEffect } from "react"
import { Link } from "react-router-dom"
import history from "../routes/history"

import { logout, path as pathsite } from "../core/utils"

export default props => {
    const [path, setPath] = useState(history.location.pathname)
    const [user, setUser] = useState({})
    useEffect(() => {
        let u = sessionStorage.getItem("user")
        setUser(JSON.parse(u))
    }, [])
    const menus = [
        { link: pathsite + "/", label: "Meus Imóveis", title: "Meus Imóveis" },
        { link: pathsite + "/contratos", label: "Contratos", title: "Contratos" },
        { link: pathsite + "/boletos", label: "Boletos", title: "Boletos" },
        { link: pathsite + "/extratos", label: "Extratos", title: "Extratos" }
    ]

    return (
        <div>
            <section className="section" style={{ paddingTop: 5, paddingBottom: 0 }}>
                <div className="container">
                    <div className="header">
                        <div className="logo" />
                        <div className="user">
                            <span>
                                {user.name}
                                <br />
                                {user.email}
                            </span>
                            <button className="button is-danger is-small" onClick={() => logout()}>
                                <i className="material-icons" style={{ fontSize: 16 }}>
                                    power_settings_new
                                </i>
                                &nbsp; Sair
                            </button>
                        </div>
                    </div>
                </div>
            </section>
            <nav className="navbar">
                <section className="section nopadding">
                    <div className="container">
                        <ul className="menu">
                            {menus.map(m => {
                                return (
                                    <li key={btoa(m.link)}>
                                        <Link
                                            to={m.link}
                                            className={path === m.link ? "active" : ""}
                                            onClick={() => setPath(m.link)}
                                        >
                                            {m.label}
                                        </Link>
                                    </li>
                                )
                            })}
                        </ul>
                    </div>
                </section>
            </nav>
        </div>
    )
}
